import { render, staticRenderFns } from "./ModalRelanceCentre.vue?vue&type=template&id=4ddc6d78&"
import script from "./ModalRelanceCentre.vue?vue&type=script&lang=js&"
export * from "./ModalRelanceCentre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports